import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

function sendErrorReport(type, message, stack, extra) {
  try {
    const token = localStorage.getItem('token');
    const endpoint = token ? '/api/errors/report' : '/api/errors/report/anon';
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;
    fetch(endpoint, {
      method: 'POST',
      headers,
      body: JSON.stringify({ type, message: String(message).substring(0, 2000), stack: stack ? String(stack).substring(0, 5000) : undefined, url: window.location.pathname, extra }),
      keepalive: true,
    }).catch(() => {});
  } catch (_) {}
}

window.addEventListener('error', (e) => {
  sendErrorReport('js_error', e.message || String(e.error), e.error?.stack, { filename: e.filename, lineno: e.lineno, colno: e.colno });
});

window.addEventListener('unhandledrejection', (e) => {
  const msg = e.reason?.message || String(e.reason) || 'Unhandled promise rejection';
  sendErrorReport('unhandled_rejection', msg, e.reason?.stack, null);
});

const _origConsoleError = console.error;
console.error = (...args) => {
  _origConsoleError.apply(console, args);
  try {
    const sanitizeForLog = (a) => {
      if (typeof a !== 'object' || a === null) return String(a);
      try {
        const safe = { message: a.message, status: a.response?.status, code: a.code, name: a.name };
        return JSON.stringify(safe);
      } catch { return '[unserializable]'; }
    };
    const msg = args.map(sanitizeForLog).join(' ').substring(0, 2000);
    sendErrorReport('console_error', msg, null, null);
  } catch (_) {}
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
